import { DialogContent, DialogActions } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ThemeButton } from '@shared/ui/buttons';

export default function HelpContentLayout({ children, close }) {
  const { t } = useTranslation();
  return (
    <>
      <DialogContent>{children}</DialogContent>
      <DialogActions>
        <ThemeButton startIcon="check" minWidth block={false} onClick={close}>
          {t('Got it')}
        </ThemeButton>
      </DialogActions>
    </>
  );
}
